import LoginSVG from "assets/loginSVG";
import ToyotaLogoSVG from "assets/toyotaLogoSVG";
import LoginLeftErrorPanel from "./components/login-left-error-panel";
import { Button, Tooltip } from "@mui/material";
import { Article } from "@mui/icons-material";
import { userGuideDoc } from "utility/constants";

const LoginErrorPage = ({triggerLogin, requestAccess}: any) => {
   
    return (
        <div style={{ padding: "8px" }}>
            <div style={{ padding: "8px", display: "flex", justifyContent: "space-between" }}>
                <ToyotaLogoSVG />
                <Tooltip title="Access the user guide">
                    <Button
                        variant="text"
                        startIcon={<Article />}
                        onClick={() => {
                            window.open(
                                userGuideDoc,
                                "_blank"
                            );
                        }}
                    >
                        User Guide
                    </Button>
                </Tooltip>
            </div>
            <div>
                <div style={{ display: "flex", justifyContent: "space-around", paddingTop: "6%" }}>
                    <div id="leftPanel" style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                        <LoginLeftErrorPanel triggerLogin={triggerLogin} requestAccess={requestAccess} />
                    </div>
                    <div id="rightPanel">
                        <LoginSVG />
                    </div>
                </div>
            </div>
        </div>
    );
  };
  
  export default LoginErrorPage;